module.exports = __webpack_public_path__ + "img/derbygo-logo-white.eeea176f.svg";